import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {DCRoadDataGameData, DCRoadDataInitData} from "./DCRoadData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {IWinRatioConfig} from "../../../core/config/WinRatio";
import {DevilsCrossRoadGameConfig} from "../../DevilsCrossRoadGameConfig";
import {DCRoadReelsController} from "../../reels/DCRoadReelsController";
import {DevilsCrossRoadGameMode} from "../DevilsCrossRoadGameMode";

export class DCRoadModel extends GameModel<DCRoadDataInitData, DCRoadDataGameData> {

    public isRestore:boolean = false;
    public isRestoreFeatureBet:boolean;
    public buyFeatureName:string;
    public allWinPositions:boolean[][];
    public currentWinRatioConfig:IWinRatioConfig | null;
    public totalWinRatioConfig:IWinRatioConfig | null;
    public waysWonTotalRound:number;
    public evaluatedArea:string[][];
    public randomWilds:[number, number][];
    public stickyCoins:string [][];
    public stickyCoinsValues:number [][];
    public previousStickyCoinsValues: number [][];
    public stickyCoinsValuesBeforeFeature:number [][];
    public featureTable:boolean [][];
    public brokeTheBank:boolean;

    public quadMultiplier:number [];
    public nextQuadMultiplier:number [];
    public collectMeter:number;
    public featuresForClient: {[key: string]: any} [];

    public featureForClientKeys: number [] = [];
    public featureClientMappedToIndex: number [][] = [];
    public featureClientValueMappedToIndex: number [] = [];
    public featureClientFlattenedTargetIndex: number [] = [];
    public featureClientTargetPositions: number [][] = [];
    public featuresMappedByStringPosition: {  [key:string] : {values: number [], featureId:string, targetPos: PIXI.Point, featureIndex:number } | null } = {};
    public featureNumericalIDsToPlay: number [] = [];
    public allFeaturesToPlay: {values: number [], featureId:string, targetPos: PIXI.Point, featureIndex:number }  [] = [];
    public numCoins: number;
    public fullScreenCoin: boolean;

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);

        api.events.once("featureBet", (data:boolean) => {
            this.isRestoreFeatureBet = data;
        });
        api.events.once("featureName", (data:string) => {
            this.buyFeatureName = data;
        });
        DevilsCrossRoad.apiPlugin.events.on(APIEvent.BET, (betData:APIFeatureBetEventData) => {
            for(let index = 0; index < DevilsCrossRoad.model.initData.featureBuyTimesBetValue.length; index++) {
                if(DevilsCrossRoad.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });
        DevilsCrossRoad.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData:APIFeatureBetEventData) => {
            for(let index = 0; index < DevilsCrossRoad.model.initData.featureBuyTimesBetValue.length; index++) {
                if(DevilsCrossRoad.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Action Spins Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });
    }

    protected onInit(data:DCRoadDataInitData):void {
        super.onInit(data);
        this.allFeaturesToPlay.length = 0;
        this.featureNumericalIDsToPlay.length = 0;
        this.isRestore = data.isRestoreState;
        this.nextQuadMultiplier = data.nextQuadMultiplier ? data.nextQuadMultiplier : [1, 1, 1, 1];
        this.quadMultiplier = data.quadMultiplier ? data.quadMultiplier : [1, 1, 1, 1];
        this.collectMeter = data.collectMeter;
        this.featureTable = data.featureTable;
        this.stickyCoinsValues = data.stickyCoinsValues;
        this.previousStickyCoinsValues = data.previousStickyCoinsValues;
        this.stickyCoinsValuesBeforeFeature = data.stickyCoinsValuesBeforeFeature;
        this.featuresForClient = data.featuresForClient;
        this.numCoins = data.numCoins;
        this.fullScreenCoin = data.fullScreenCoin;

        const featureClientMappedToIndex: number [][] = [ // Every feature index, eg. top {0,1...} right {0,1...}
            [],[],[],[],[],[],[],[],[],[]
        ];
        const featureClientValueMappedToIndex: number [] = [];
        const keys: string [] = [];
        const numericalStrKeys: string [] = [];

        const toFlatTargetPosition : number [][] = [
            [-1, -1, -1, -1 , -1, -1],
            [-1, -1, -1, -1 , -1, -1],
            [-1, -1, -1, -1 , -1, -1],
            [-1, -1, -1, -1 , -1, -1],
            [-1, -1, -1, -1 , -1, -1],
            [-1, -1, -1, -1 , -1, -1],
        ];
        const featureClientTargetPositions: number [][] = [];

        const keysInt: number [] = keys.map(Number);
        this.featureForClientKeys = keysInt;

        const mappedByStringPos: { [key:string] : number [] } = {};

        const featuresMappedByStringPosition: {  [key:string] : {values: number [], featureId:string, targetPos: PIXI.Point, featureIndex:number   } | null } = {};

        this.featuresForClient.forEach((obj) => {
            keys.push(Object.keys(obj)[0]);
            //featureTargetPosition[Number(Object.keys(obj)[0])] = obj[Object.keys(obj)[0]][0][0];
            (Object.keys(obj[Object.keys(obj)[0]][0][0]) as (keyof typeof obj)[]).forEach((key, index) => {

                //console.log(key, obj[Object.keys(obj)[0]][0][0][key], index);
                const x:number = obj[Object.keys(obj)[0]][0][0][key][0];
                const y:number = obj[Object.keys(obj)[0]][0][0][key][1];

                toFlatTargetPosition[x][y] = -2;
                featureClientTargetPositions.push(obj[Object.keys(obj)[0]][0][0][key]);
                mappedByStringPos["x:" + x + "y:" + y] = obj[Object.keys(obj)[0]][0][1][0][0];
                if(featuresMappedByStringPosition) {
                    featuresMappedByStringPosition["x:" + x + "y:" + y] = {
                        values: obj[Object.keys(obj)[0]][0][1][0][0],
                        featureId: key.toString(),
                        targetPos: new PIXI.Point(x, y),
                        featureIndex: Number(Object.keys(obj)[0])
                    };
                    this.allFeaturesToPlay.push({
                        values: obj[Object.keys(obj)[0]][0][1][0][0],
                        featureId: key.toString(),
                        targetPos: new PIXI.Point(x, y),
                        featureIndex: Number(Object.keys(obj)[0])
                    });
                }
                //debugger;

            });
            featureClientMappedToIndex[Number(Object.keys(obj)[0])] = obj[Object.keys(obj)[0]][0][1][0][0]; // TODO: Sort/map it by index from server.
            featureClientValueMappedToIndex[Number(Object.keys(obj)[0])] = obj[Object.keys(obj)[0]][0][1][0][1];
            numericalStrKeys.push(Object.keys(obj)[0]);
        });

        //console.log("FOOOBOOOO", mappedByStringPos);
        //console.log("FOOOBOOOO2", featuresMappedByStringPosition);
        //console.log("FOOOBOOOO3", numericalStrKeys);

        numericalStrKeys.forEach((str) => {
            this.featureNumericalIDsToPlay.push(Number(str));
        });
        //console.log("FOOOBOOOO4", this.featureNumericalIDsToPlay);
        //console.log("FOOOBOOOO5", this.allFeaturesToPlay);

        // TODO: Ordering of feature values get's mixed up, probably.
        this.featuresMappedByStringPosition = featuresMappedByStringPosition;

        //toFlatTargetPosition;
        //debugger;

        this.featureClientTargetPositions = featureClientTargetPositions;
        this.featureClientMappedToIndex = featureClientMappedToIndex;
        this.featureClientValueMappedToIndex = featureClientValueMappedToIndex;

        const myClonedArray:number [][] = Object.assign([], toFlatTargetPosition);
        this.featureClientFlattenedTargetIndex = myClonedArray.reduce((accumulator, value) => accumulator.concat(value), []);
        this.featureClientFlattenedTargetIndex.forEach((val, index) => {
            if(val === -2) {
                this.featureClientFlattenedTargetIndex[index] = index;
            }
        });

        //console.log("FEAT CLIENT TARGETS", this.featureClientTargetPositions);
        //debugger;
    }

    protected onGame(data:DCRoadDataGameData):void {
        super.onGame(data);
        this.allFeaturesToPlay.length = 0;
        this.featureNumericalIDsToPlay.length = 0;
        this.isRestore = false;
        this.allWinPositions = data.allWinPositions;
        this.currentWinRatioConfig = this.parseWinRatio(data.thisSpinWinning / data.playedBetValue);
        this.totalWinRatioConfig = this.parseWinRatio(data.accumulatedRoundWin / data.playedBetValue);
        this.waysWonTotalRound = data.waysWonTotalRound;
        this.evaluatedArea = data.evaluatedArea;
        this.randomWilds = this.parseRandomWilds();
        this.stickyCoins = data.stickyCoins;
        this.stickyCoinsValues = data.stickyCoinsValues;
        this.previousStickyCoinsValues = data.previousStickyCoinsValues;
        this.stickyCoinsValuesBeforeFeature = data.stickyCoinsValuesBeforeFeature;
        this.featureTable = data.featureTable;
        this.nextQuadMultiplier = data.nextQuadMultiplier;
        this.quadMultiplier = data.quadMultiplier;
        this.collectMeter = data.collectMeter;
        this.featuresForClient = data.featuresForClient;
        this.brokeTheBank= data.brokeTheBank;
        this.numCoins = data.numCoins;
        this.fullScreenCoin = data.fullScreenCoin;

        const featureClientMappedToIndex: number [][] = [
            [],[],[],[],[],[],[],[],[],[]
        ];
        const featureClientValueMappedToIndex: number [] = [];
        const featureClientTargetPositions: number [][] = [];
        const keys: string [] = [];

        const toFlatTargetPosition : number [][] = [
            [-1, -1, -1, -1 , -1, -1],
            [-1, -1, -1, -1 , -1, -1],
            [-1, -1, -1, -1 , -1, -1],
            [-1, -1, -1, -1 , -1, -1],
            [-1, -1, -1, -1 , -1, -1],
            [-1, -1, -1, -1 , -1, -1],
        ];
        const keysInt: number [] = keys.map(Number);
        this.featureForClientKeys = keysInt;

        const numericalStrKeys: string [] = [];

        const mappedByStringPos: { [key:string] : number [] } = {
        };

        const featuresMappedByStringPosition: {  [key:string] : {values: number [], featureId:string, targetPos: PIXI.Point, featureIndex:number   } | null } = {};

        this.featuresForClient.forEach((obj) => {
            this.featuresForClient;
            keys.push(Object.keys(obj)[0]);
            //featureTargetPosition[Number(Object.keys(obj)[0])] = obj[Object.keys(obj)[0]][0][0];
            (Object.keys(obj[Object.keys(obj)[0]][0][0]) as (keyof typeof obj)[]).forEach((key, index) => {

                //console.log(key, obj[Object.keys(obj)[0]][0][0][key], index);
                const x:number = obj[Object.keys(obj)[0]][0][0][key][0];
                const y:number = obj[Object.keys(obj)[0]][0][0][key][1];

                toFlatTargetPosition[x][y] = -2;
                featureClientTargetPositions.push(obj[Object.keys(obj)[0]][0][0][key]);
                mappedByStringPos["x:" + x + "y:" + y] = obj[Object.keys(obj)[0]][0][1][0][0];
                if(featuresMappedByStringPosition) {
                    featuresMappedByStringPosition["x:" + x + "y:" + y] = {
                        values: obj[Object.keys(obj)[0]][0][1][0][0],
                        featureId: key.toString(),
                        targetPos: new PIXI.Point(x, y),
                        featureIndex: Number(Object.keys(obj)[0])
                    }
                    this.allFeaturesToPlay.push({
                        values: obj[Object.keys(obj)[0]][0][1][0][0],
                        featureId: key.toString(),
                        targetPos: new PIXI.Point(x, y),
                        featureIndex: Number(Object.keys(obj)[0])
                    });
                }
            });
            featureClientMappedToIndex[Number(Object.keys(obj)[0])] = obj[Object.keys(obj)[0]][0][1][0][0];
            featureClientValueMappedToIndex[Number(Object.keys(obj)[0])] = obj[Object.keys(obj)[0]][0][1][0][1];
            numericalStrKeys.push(Object.keys(obj)[0]);
        });

        //mappedByStringPos['hej'] = [3, 2, 1];
        //console.log("FOOOBOOOO", mappedByStringPos);
        //console.log("FOOOBOOOO2", featuresMappedByStringPosition);
        //console.log("FOOOBOOOO3", numericalStrKeys);

        numericalStrKeys.forEach((str) => {
            this.featureNumericalIDsToPlay.push(Number(str));
        });
        //console.log("FOOOBOOOO4", this.featureNumericalIDsToPlay);
        //console.log("FOOOBOOOO5", this.allFeaturesToPlay);

        this.featuresMappedByStringPosition = featuresMappedByStringPosition;

        this.featureClientTargetPositions = featureClientTargetPositions;
        this.featureClientMappedToIndex = featureClientMappedToIndex;
        this.featureClientValueMappedToIndex = featureClientValueMappedToIndex;

        const myClonedArray:number [][] = Object.assign([], toFlatTargetPosition);
        this.featureClientFlattenedTargetIndex = myClonedArray.reduce((accumulator, value) => accumulator.concat(value), []);
        this.featureClientFlattenedTargetIndex.forEach((val, index) => {
            if(val === -2) {
                this.featureClientFlattenedTargetIndex[index] = index;
            }
        });
        //console.log("MAPPED OBJECT", this.featureClientFlattenedTargetIndex);
        //debugger;
        //console.log("FEAT CLIENT FLAT", this.featureClientFlattenedTargetIndex);
    }

    private parseWinRatio(winRatio:number):IWinRatioConfig | null {
        let ratioConfigs:IWinRatioConfig[] = DevilsCrossRoadGameConfig.WIN_RATIOS;

        let ratioConfig;
        for(let i:number = ratioConfigs.length - 1; i >= 0; i--) {
            const config = ratioConfigs[i];
            if((winRatio > config.ratio) || (!config.startRatioExcluded && winRatio == config.ratio)) {
                ratioConfig = config;
                break;
            }
        }

        if(ratioConfig) {
            return {
                ratio : winRatio,
                startRatioExcluded : ratioConfig.startRatioExcluded,
                name : ratioConfig.name,
                duration : ratioConfig.duration,
                winLevel : ratioConfig.winLevel,
                bigWinLevel : ratioConfig.bigWinLevel
            };
        }
        return null;
    }

    private parseRandomWilds():[number, number][] {
        const result:[number, number][] = [];
        if(this.data.mode.includes(DevilsCrossRoadGameMode.FREESPIN)) {
            return result;
        }
        DCRoadReelsController.DEV_WAY_COORDS.forEach(coords => {
            const coord = coords[0];
            if(this.evaluatedArea[coord[0]][coord[1]] === "W" && this.data.reels[coord[0]][coord[1]] != "W") {
                result.push(coord);
            }
        });
        return result;
    }

    public getFeatureActivatedByArea(area:string):boolean [] {
        if(area === "top") {
            return [this.featureTable[0][0], this.featureTable[1][0], this.featureTable[2][0], this.featureTable[3][0], this.featureTable[4][0]];
        } else if(area === "right") {
            return [this.featureTable[5][1], this.featureTable[5][2], this.featureTable[5][3], this.featureTable[5][4], this.featureTable[5][5]];
        }

        return [];
    }



    public isWithinRangeForGoatTease():boolean {
        const isWithinCoinRange: boolean = this.numCoins >= 8 && this.numCoins < 20;

        let featCntr:number = 0;
        this.featureClientMappedToIndex.forEach((featArr) => {

            if(featArr.length > 0) {
                let add:number = 1;
                featArr.forEach((val) => {
                    if(val < 1) {
                        add = 0;
                    }
                });

                featCntr += add;
            }
        });
        const isWithinFeatureLimit: boolean = featCntr <= 2;

        return isWithinCoinRange && isWithinFeatureLimit;
    }

    public getTotalFsXwin():number {
        const value:number = (this.stickyCoinsValues[5][0]) ? this.stickyCoinsValues[5][0] : 0;
        return value;
    }

    public getTotalPreviousFsXwin():number {
        const value:number = (this.previousStickyCoinsValues[5][0]) ? this.previousStickyCoinsValues[5][0] : 0;
        return value;
    }
}